import { ACCOUNTS_SERVICE_URI } from "env";
import { assertOk, proxyFetch } from "./utils";

const accountsProxy = proxyFetch(ACCOUNTS_SERVICE_URI);

export const getGeoData = async (ctx, ipAddress) => {
  const response = await accountsProxy(ctx, `/ip-lookup?ip_address=${ipAddress}`, "GET");
  assertOk(response);
  return response.json();
};

export const getTOSStatus = async ctx => {
  const response = await accountsProxy(ctx, `/v1/user-info/tos/tilia`, "GET");
  assertOk(response);
  return response.json();
};

export const signTiliaTOS = async ctx => {
  const response = await accountsProxy(ctx, `/v1/user-info/tos/tilia`, "POST");
  assertOk(response);
  return response.json();
};
